import * as React from 'react';
import styled from 'styled-components';

import theme from '../../theme';

export default styled.div`
  padding: ${p => theme.spacing.unit * 2}px;
`;
